import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {CurrencyPipe} from "@angular/common";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-calculator-control",
    styleUrls: ["./calculator-control.component.scss"],
    templateUrl: "./calculator-control.component.html"
})
export class FUICalculatorControlComponent {
    @Input() public factor: number = 0;
    @Input() public operation: string;
    public quotient: any;
    @Output() public $quotient: EventEmitter<any>;
    @Input() type: string;
    @Input() public value: number = 0;

    constructor(private currencyPipe: CurrencyPipe) {
        this.$quotient = new EventEmitter<number>();
    }

    /**
     *
     * @returns {number}
     */
    setQuotient(): number {
        switch (this.operation) {
            case "multiply":
                if (this.type === "currency") {
                    this.quotient = this.currencyPipe.transform(this.value * this.factor, "AUD", true);
                }
                else {
                    this.quotient = this.value * this.factor;
                }

                this.$quotient.emit(this.quotient);

                return this.quotient;
            case "add":
                this.quotient = this.value + this.factor;
                this.$quotient.emit(this.quotient);

                return this.quotient;
            case "subtract":
                this.quotient = this.value - this.factor;
                this.$quotient.emit(this.quotient);

                return this.quotient;
            case "divide":
                this.quotient = this.value / this.factor;
                this.$quotient.emit(this.quotient);

                return this.quotient;
            default:
                if (this.type === "currency") {
                    this.quotient = this.currencyPipe.transform(this.value * this.factor, "AUD", true);
                }
                else {
                    this.quotient = this.value * this.factor;
                }

                this.$quotient.emit(this.quotient);

                return this.quotient;
        }
    }
}
